import { Injectable } from '@angular/core';
import { ModuleV1Read } from '@ca/core/models';
import { ModulesV1Service } from '@ca/core/services';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { TranslateService } from '@ngx-translate/core';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import * as actions from './common.actions';

@Injectable()
export class CommonEffects {
    loadSystemModules$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actions.loadSystemModules),
            switchMap(() =>
                this.modulesV1Service.getSystemModules().pipe(
                    map((resp: ModuleV1Read[]) => actions.loadSystemModulesSuccess({ systemModules: resp || [] })),
                    catchError(() => {
                        return of(actions.loadSystemModulesFailed({ error: this.translateService.instant('MODULES.LOAD_SYSTEM_MODULES_FAILED') }));
                    }),
                ),
            ),
        ),
    );

    constructor(
        private actions$: Actions,
        private translateService: TranslateService,
        private modulesV1Service: ModulesV1Service,
    ) {}
}
